import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BasePagingResponse } from "@app/ui_models/basePagingResponse";
import { UserDto } from "@app/ui_models/userDto";
import { env } from "@environments/environment";

@Injectable({ providedIn: "root" })
export class UserController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;

  public currentUserContext(): Observable<any>  {
    return this.httpService.get("/logistics/v1/user/current/context", { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public getExperts(page: number, size: number): Observable<BasePagingResponse<UserDto>> {
    let params = new HttpParams();
    const sortFieldAndOrder = "username, ASC";
    params = params.append("sort", sortFieldAndOrder);
    params = params.append("page", page);
    params = params.append("size", size);
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/organization/experts", { responseType: "text", params }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

}
